export const API_SERVER = process.env.VUE_APP_API_SERVER
export const TELEGRAM_URL = process.env.VUE_APP_TELEGRAM_URL
export const LANDING_URL = process.env.VUE_APP_LANDING
export const AMPLITUDE_KEY = process.env.VUE_APP_AMPLITUDE_KEY
export const TELEGRAM_SUPPORT = process.env.VUE_APP_TELEGRAM_SUPPORT
export const TELEGRAM_BOT_NAME = process.env.VUE_APP_TELEGRAM_BOT_NAME
export const REDIRECT_URL = process.env.VUE_APP_REDIRECT_URL
export const CHROME_EXTENSION_LINK = process.env.VUE_APP_CHROME_EXTENSION_LINK
export const FIREFOX_EXTENSION_LINK = 'https://addons.mozilla.org/en-US/firefox/addon/metrica/'
